import React, { useState, useRef, useEffect } from "react";
import {
  Drawer,
  Button,
  Message,
  Input,
  Checkbox,
  Collapse,
  Radio
} from "@arco-design/web-react";
import "./index.less";
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
import MinganTitle from "@/assets/cut-mix-detail/mingan-title-min.png";
import TitleGroup from "@/pages/VideoClips/MixCutDetail/FontTitle/TitleGroup/TitleGroup";
import VoLongButton from "@/components/VLButton/VLButton";
import SenDeleteImg from "@/assets/cut-mix-detail/sensi-delete-min.png";
import SenEdit from "@/assets/cut-mix-detail/sensi-edit-min.png";
import ZhanImg from "@/assets/cut-mix-detail/zhunhuan.png";
import HasZhuanImg from "@/assets/cut-mix-detail/haszhuan.png";
import HasEdit from '@/assets/cut-mix-detail/has-edit.png';
import HasDelete from '@/assets/cut-mix-detail/has-delete.png'
import {empty_icon} from "@/assets/workbenchimage";
type Props = {
  isOpen: boolean;
  handleCancel: () => void;
  total_words: number;
  total_sensitive: number;
  sensitiveList: any;
  emitChange: (data: any, type: number) => void;
};
// 定义类型
interface SensitiveWordReplacement {
  sensitive_words: string;
  replacements: string;
  newWord?: string;
}

interface WordList {
  name: string;
  sensitive_words: string[];
  replacements: string[];
}
const SensitiveListDrawer = (props: Props) => {
  const {
    isOpen,
    handleCancel,
    total_words,
    total_sensitive,
    sensitiveList,
    emitChange
  } = props;
  const [typeIndex, setTypeIndex] = useState(0);
  const [editName, setEditName] = useState("");
  const inputRef = useRef(null);
  const [editId, setEditId] = useState(null);
  const [checkAll, setCheckAll] = useState(false);
  const [lineCount, setLineCount] = useState(0);
  const [titleCount, setTitleCount] = useState(0);
  const [checkList, setCheckList] = useState([]);
  const [lineList, setLineList] = useState([]);
  const [titleList, setTitleList] = useState([]);
  const [editFlag, setEditFlag] = useState(false);
  useEffect(() => {
    const line = [];
    const title = [];
    if (isOpen) {
      sensitiveList.forEach((item, index) => {
        line.push(item.caption_groups)
        title.push(item.title_groups)
      });
      setLineList(setNewArr(line.flat()))
      setLineCount(setNewArr(line.flat()).length)
      setTitleList(setNewArr(title.flat()))
      setTitleCount(setNewArr(title.flat()).length)
    } else {
      setCheckAll(false)
    }
  }, [isOpen]);

  useEffect(() => {
    if (checkAll) {
      if (typeIndex === 0) {
        setCheckList(lineList.filter((item) => item.newWord?.length === 0).map(item => item.sensitive_words))
      } else {
        setCheckList(titleList.filter((item) => item.newWord?.length === 0).map(item => item.sensitive_words))
      }
    } else {
      setCheckList([])
    }
  }, [checkAll]);
  // 去重
  const setNewArr = (arr: WordList[]) => {
    const uniqueSensitiveWords: { [key: string]: SensitiveWordReplacement } = {};
    const newArr: SensitiveWordReplacement[] = [];
    // 过滤掉没有 sensitive_words 和 replacements 字段的对象
    const filteredArr = arr.filter(obj => Array.isArray(obj?.sensitive_words) && Array.isArray(obj?.replacements));
    filteredArr.forEach(obj => {
      if (obj?.sensitive_words) {
        obj?.sensitive_words.forEach((word, index) => {
          const replacement = obj.replacements[index];
          const key = `${word}:${replacement}`;
          if (!uniqueSensitiveWords[key]) {
            uniqueSensitiveWords[key] = { sensitive_words: word, replacements: replacement };
            newArr.push({ sensitive_words: word, replacements: replacement, newWord: '' });
          }
        });
      }
    });

    return newArr;
  }
  // 删除
  const changeName = (name) => {
    setEditName(name);
  };
  // 批量替换
  useEffect(() => {
    if (editId && inputRef) {
      inputRef.current.focus();
    }
  }, [editId]);

  // 批量删除
  const deleteAll = () => {
    if (checkList?.length === 0) {
      return false
    }
    const newArr = [...checkList]
    const newLineList = [...lineList]
    const newTitleList = [...titleList]
    const deleteArr = []
    if (typeIndex === 0) {
      newLineList.forEach(item => {
        if (checkList.includes(item.sensitive_words)) {
          deleteArr.push({
            sensitive_words: item.sensitive_words,
            newWord: ''
          })
        }
      })
      handleChange(deleteArr, typeIndex)
      setLineList(newLineList.filter(item => !newArr.includes(item.sensitive_words)))
      setLineCount(newLineList.filter(item => !newArr.includes(item.sensitive_words)).length)
      setCheckList([])
    } else {
      newTitleList.forEach(item => {
        if (checkList.includes(item.sensitive_words)) {
          deleteArr.push({
            sensitive_words: item.sensitive_words,
            newWord: ''
          })
        }
      })
      handleChange(deleteArr, typeIndex)
      setTitleList(newTitleList.filter(item => !newArr.includes(item.sensitive_words)))
      setTitleCount(newTitleList.filter(item => !newArr.includes(item.sensitive_words)).length)
      setCheckList([])
    }
  }

  // 一键替换
  const clickAllReplace = () => {
    const newLineList = [...lineList]
    const newTitleList = [...titleList]
    const replaceArr = []
    const newList = typeIndex === 0 ? newLineList : newTitleList
    newList.forEach(item => {
      if (checkList.includes(item.sensitive_words)) {
        item.newWord = item.replacements
        replaceArr.push({
          sensitive_words: item.sensitive_words,
          newWord: item.replacements
        })
      }
    })
    handleChange(replaceArr, typeIndex)
    if (typeIndex === 0) {
      setLineList(newList)
    } else {
      setTitleList(newList)
    }
    setCheckAll(false)
    setCheckList([])
  }
  // 单个选中
  const checkboxClick = (value) => {
    const newArr = [...checkList]
    if (newArr.includes(value)) {
      newArr.splice(newArr.indexOf(value), 1)
    } else {
      newArr.push(value)
    }
    setCheckList(newArr)
  }

  // 单个修改
  const editHanlde = (data) => {
    if (data.newWord) {
      return false
    }
    setEditId(data.sensitive_words)
    setEditFlag(true)
  }
  // 单个删除
  const deleteHanlde = (index, data) => {
    if (data.newWord) {
      return false
    }
    const replaceArr = []
    const newArr = typeIndex === 0 ? [...lineList] : [...titleList]
    // 台词组删除
    replaceArr.push({
      sensitive_words: data.sensitive_words,
      newWord: ''
    })
    newArr.splice(index, 1)
    if (typeIndex === 0) {
      setLineCount(newArr.length)
      setLineList(newArr)
    } else {
      setTitleCount(newArr.length)
      setTitleList(newArr)
    }
    handleChange(replaceArr, typeIndex)
  }
  // 替换单个
  const replaceHandle = (item, index) => {
    if (item.newWord) {
      return false
    }
    const newArr = typeIndex === 0 ? [...lineList] : [...titleList]
    if (typeIndex === 0) {
      newArr[index].newWord = item.replacements
      handleChange([newArr[index]], typeIndex)
      setLineList(newArr)
    } else {
      newArr[index].newWord = item.replacements
      handleChange([newArr[index]], typeIndex)
      setTitleList(newArr)
    }
  }
  // 替换数据
  const handleChange = (data, type) => {
    emitChange(data, type);
  }
  return (
    <div>
      <Drawer
        width={555}
        title={
          <div className="mingan-header">
            <img src={MinganTitle} alt="" />
            <span>敏感词检测</span>
          </div>
        }
        visible={isOpen}
        footer={null}
        onCancel={() => {
          handleCancel();
        }}>
        <div className="sensitive-btns">
          <RadioGroup
            type='button'
            defaultValue={typeIndex}
            style={{marginRight: 20, marginBottom: 20}}
            onChange={(e) => {
              setTypeIndex(e)
              setCheckList([])
              setCheckAll(false)
            }}
          >
            <Radio value={0}>台词组 {
              lineCount > 0 && <div className={"circle-title"}>{lineCount}</div>
            }</Radio>
            <Radio value={1}>标题组 {
            titleCount > 0 && <div className={"circle-title"}>{titleCount}</div>
            }</Radio>
          </RadioGroup>
          <div className="sensitive-desc">
            <span style={{marginRight: "5px"}}>共检测：{total_words}字</span>{" "}
            敏感词：<span style={{color: "#F53F3F"}}>{total_sensitive}</span> 字
          </div>
        </div>
        <div className="sensitive-content">
          <div className="sensitive-item-btns">
            <Checkbox
              checked={checkAll}
              onChange={(e) => {
                setCheckAll(e);
              }}
              disabled={typeIndex === 0 ? !lineList.length : !titleList.length}
              style={{ marginLeft: "8px" }}
            >全选</Checkbox>
            <div style={{ display: 'flex' }}>
              <div
                onClick={() => {
                  deleteAll();
                }}
                className="all-delete"
                style={{marginRight: "5px", background: "#fff", cursor: checkList?.length > 0 ? 'pointer' : 'no-drop'}}>
                批量删除
              </div>
              <VoLongButton
                style={{fontSize: "14px"}}
                type="primary"
                disabled={!checkList?.length}
                onClick={() => {
                  clickAllReplace();
                }}>
                一键批量替换
              </VoLongButton>
            </div>
          </div>
          <div>
            {
              (typeIndex === 0 ? lineList : titleList).map((item, index) => {
                return (
                  <div key={item.sensitive_words + index} className="sensitive-item">
                    <div className="sensitive-item-line">
                      <div className="con-left">
                        <Checkbox
                          disabled={item.newWord}
                          onChange={() => {
                            checkboxClick(item.sensitive_words);
                          }}
                          checked={checkList.includes(item.sensitive_words)}
                          style={{marginRight: "10px"}}
                        />
                        {
                          <span
                            className={
                              item.newWord
                                ? "edit-replace"
                                : "line"
                            }>
                            {item.newWord
                              ? item.newWord
                              : item.sensitive_words}
                          </span>
                        }
                      </div>
                      <div className="con-btn">
                        {
                          editId !== item.sensitive_words && <>
                            <img
                              style={{marginRight: 10}}
                              src={item.newWord ? HasDelete : SenDeleteImg}
                              alt=""
                              onClick={() => {
                                deleteHanlde(index, item);
                              }}
                            />
                            <img
                              src={item.newWord ? HasEdit : SenEdit}
                              alt=""
                              onClick={() => {
                                editHanlde(item);
                              }}
                            />
                          </>
                        }
                        {editFlag && editId === item.sensitive_words && (
                          <Input
                            onBlur={() => {
                              item.newWord = editName;
                              handleChange([item], typeIndex);
                              setEditId(0);
                              setEditFlag(false);
                            }}
                            ref={inputRef}
                            className="editInput"
                            onChange={(e) => {
                              changeName(e);
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="sensitive-item-info">
                      <div style={{marginRight: "9px"}}>
                        替换词：{item.replacements}
                      </div>
                      <img
                        onClick={() => {
                          replaceHandle(item, index);
                        }}
                        src={
                          item.newWord
                            ? HasZhuanImg
                            : ZhanImg
                        }
                        alt=""
                      />
                    </div>
                  </div>
                );
              })
            }
            {
              !((typeIndex === 0 ? lineList : titleList).length) && (
                <div className="empty-box">
                  <div>
                    <img src={empty_icon} alt="" width={100} style={{ margin: '0 auto' }}/>
                    <div style={{marginTop: 10, textAlign: 'center'}}>暂无数据</div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default SensitiveListDrawer;
